export enum ExistingServicePhase {
  SinglePhase,
  ThreePhase,
}
